import React from 'react';
import PropTypes from 'prop-types';
import { languageRouteTypes } from '@helpers/languageRoutes';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { cardTypes } from '../../helpers/ObjectTypeModels/Card';
import { ChildContainer } from '../GeotabGridComponents';
import { Card } from '../Cards/Card';
import { getLanguageRouteAndPrefixByCodeAndRouteKey } from '@helpers/languages';
import { Grid } from '@mui/material';

export function RelatedPosts({ pressReleaseList }) {
    const [selectedLanguage] = useAtom(selectedLanguageAtom);

    return (
        <ChildContainer breakSpaceValue={2}>
            {Array.isArray(pressReleaseList)
                ? pressReleaseList.map((pressRelease, index) => {
                    const cardContent = {
                        title: pressRelease.title,
                        body: pressRelease.description,
                        image: {
                            imagePath: pressRelease.cardImageUrl,
                            mobilePath: pressRelease.mobileCardImageUrl,
                            imageAlt: pressRelease.cardImageAlt,
                            lazyLoad: true,
                        },
                        publishedDateUtc: pressRelease.publishedDateUtc,
                    };
                    return index < 3 ? (
                        <Grid item xs={12} md={6} lg={12} key={index}>
                            <Card
                                card={{
                                    ...cardTypes.PRESS_ROOM_RELATED,
                                    content: cardContent,
                                }}
                                href={`${getLanguageRouteAndPrefixByCodeAndRouteKey(
                                    selectedLanguage,
                                    languageRouteTypes.PRESS_RELEASE
                                )}${pressRelease.slug}`}
                                data-testid={`pressReleaseCard${index}`}
                            />
                        </Grid>
                    ) : null;
                })
                : null}
        </ChildContainer>
    );
}

RelatedPosts.propTypes = {
    pressReleaseList: PropTypes.arrayOf(PropTypes.object).isRequired,
};
